
import { RevAccordionItem } from '@ds/components/Accordion'
import { RevAccordionList } from '@ds/components/AccordionList'

import translations from './Faq.translations'

export default {
  components: {
    RevAccordionItem,
    RevAccordionList,
  },
  computed: {
    translations: () => translations,
  },
}
